import React from 'react';

import TalentAssessmentPage from 'components/Members/TalentAssessment/Views/Show/Index';

import { useContext } from 'components/Members/Onboarding/Context';

import StepTab from 'components/new_ui/Tabs/StepTab';

import routes from 'app/routes';

import { useContext as useUsersContext } from 'components/Users/Context';

import {
  useNavigate,
} from 'react-router-dom';

export default function TalentAssessmentReport() {
  const { dispatch, state, actions } = useContext();

  const { state: stateUser } = useUsersContext();

  const navigate = useNavigate();

  const onGoNextClick = () => {
    if (state.isSecondProgramOnboarding && state.workflow === 'CPA_PROGRAM_ONBOARDING') {
      actions.complete(state.programId, () => {
        if (stateUser.user && stateUser.user.attributes.is_mobile_login) {
          navigate(routes.members.onboarding.webview);
        } else {
          document.location.href = routes.members.programs.index;
        }
      });
    } else {
      actions.completeStep(state.steps[state.currentStep].step, () => {
        actions.setNextStep({
          dispatch,
          steps: state.steps,
          isPossibleSkip: false,
          currentStep: state.currentStep,
        });
      });
    }
  };

  return (
    <div className="onboarding-content">
      {state.workflow === 'PROGRAM_ONBOARDING' && <StepTab total={5} current={1} />}

      {state.workflow === 'RETURN_TO_WORK_ONBOARDING'
        ? (
          <TalentAssessmentPage
            onNextStep={onGoNextClick}
            title="Health and Performance Assessment"
            subTitle="Your Health and Performance Assessment Report is Ready!"
            dscription={(
              <p>
                Based on your Assessment, we identify your workplace strengths and development areas.
                View recommendations in the Productivity and Wellbeing tabs below.
                Your report will be automatically emailed or you can download it here.
              </p>
          )}
          />
        )
        : (
          <TalentAssessmentPage
            onNextStep={onGoNextClick}
          />
        )}

    </div>
  );
}
